module.exports = __webpack_public_path__ + "img/placeholder-pdf.601314c4.jpg";